<template>

        <spatial-filter @click="search" :target-slug="targetSlug">

        </spatial-filter>

</template>

<script>

import AdminUnitSpatialFilter from "../filters/AdminUnitSpatialFilter";

export default {

    components: {
        "spatial-filter": AdminUnitSpatialFilter,
    },


    props: {
        targetSlug: {
            type: String,
            required: true,
        },

    },

    data() {

        return {

            filterUrl: window.APP_URL + "/spatial/filter/",
        };

    },

    computed: {

    },

    mounted() {

    },

    methods: {

        search(currentlySelected)
        {
            let url = this.filterUrl;

            if(currentlySelected.name === 'Nation')
                url = url + this.targetSlug;

            else if (currentlySelected.slug && currentlySelected.id)
                url = url + currentlySelected.slug + '/' + currentlySelected.id + '/' + this.targetSlug;

            window.axios.get(url)
                .then((response) => {

                    this.$emit('search', response.data);
                
                })
                .catch(error => {
                    window.alert(error);
                });

        },
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/filters/AdminUnitSpatialSearcher.vue